import React from "react";
import PropTypes from "prop-types";
import {
  getPathogenicDbs,
  getUncertainDbs,
  getBenignDbs,
  getMetaScoresDbs,
  countBenignDbsSum,
  countPathogenicDbsSum,
  countUncertainDbsSum,
} from "../helpers/genericHelpers";
import { HorizontalStackedBar } from "../../../../../../components/atoms";
import {
  uncertainSignificanceColor,
  benignStrongColor,
  pathogenicStrongColor,
} from "../../../../../../common/helpers/colors";

const MetaScoresBarchart = ({ insilicoDbs, forceDisabledToolTip }) => {
  const metaScoresDbs = getMetaScoresDbs(insilicoDbs);
  const pathogenicDbs = getPathogenicDbs(metaScoresDbs);
  const uncertainDbs = getUncertainDbs(metaScoresDbs);
  const benignDbs = getBenignDbs(metaScoresDbs);
  const pathogenicDbsSum = countPathogenicDbsSum(metaScoresDbs);
  const benignDbsSum = countBenignDbsSum(metaScoresDbs);
  const uncertainDbsSum = countUncertainDbsSum(metaScoresDbs);

  const metaScoresPredictionsBarData = [
    {
      value: pathogenicDbsSum,
      color: pathogenicStrongColor,
      text: `${pathogenicDbsSum}`,
      renderDataArray: pathogenicDbs.map((i) => i.name),
    },
    {
      value: uncertainDbsSum,
      color: uncertainSignificanceColor,
      text: `${uncertainDbsSum}`,
      renderDataArray: uncertainDbs.map((i) => i.name),
    },
    {
      value: benignDbsSum,
      color: benignStrongColor,
      text: `${benignDbsSum}`,
      renderDataArray: benignDbs.map((i) => i.name),
    },
  ];

  const metaScoresExists =
    metaScoresPredictionsBarData
      .map((elem) => elem.value)
      .reduce((prev, cur) => prev + cur, 0) > 0;

  if (!metaScoresExists) return null;

  return (
    <>
      <HorizontalStackedBar
        className="tw-h-3 tw-text-xs"
        data={metaScoresPredictionsBarData}
        forceDisabledToolTip={forceDisabledToolTip}
      />
    </>
  );
};

MetaScoresBarchart.propTypes = {
  insilicoDbs: PropTypes.arrayOf(PropTypes.shape({})),
  forceDisabledToolTip: PropTypes.bool,
};

MetaScoresBarchart.defaultProps = {
  insilicoDbs: null,
  forceDisabledToolTip: null,
};

export default MetaScoresBarchart;
